export const AUTH_USER_STORAGE_KEY = "moderatorUser";
export const AUTH_TOKEN_STORAGE_KEY = "moderatorToken";

export const getStoredUser = () => {
  const persistedUser = localStorage.getItem(AUTH_USER_STORAGE_KEY);
  return persistedUser ? JSON.parse(persistedUser) : null;
};

export const persistUser = (user: unknown) => {
  localStorage.setItem(AUTH_USER_STORAGE_KEY, JSON.stringify(user));
};

export const persistToken = (token: string | undefined) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
  }
};

export const clearAuthStorage = () => {
  localStorage.removeItem(AUTH_USER_STORAGE_KEY);
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
};

export const getStoredToken = () => localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
